export enum PaymentStatus {
  Pending = 0,
  Success = 1,
  Failed = 2,
  Error = 3,
  // AttemptPayment = 3
}
